export const payrollPtBr = {
  reasonRequired: 'Informe o motivo da alteração.',
  budgetImmutable: 'O cenário de folha só pode ser alterado em orçamentos em rascunho ou ativos.',
  unallocatedImpact: 'Sem linha orçamentária: {{before}} → {{after}}.',
  snapshotRestricted:
    'Este relatório congelado pode conter folha. É necessário acesso a dados de folha para abri-lo; os valores históricos não são recalculados.',
  loading: 'Carregando configuração de folha',
  saving: 'Salvando alteração',
  saved: 'Alteração aplicada aos orçamentos vinculados.',
  close: 'Fechar',
  retry: 'Tentar novamente',
  impactStale: 'Os dados mudaram. Revise novamente o impacto e confirme a alteração.',
  invalidScenario:
    'Selecione um cenário ativo com exatamente um modelo de folha, válido para esta entidade.',
  defaultRequired:
    'O cenário padrão de folha deve permanecer ativo com sua regra de folha. Configure-o na aba Folha.',

  partialCoverage: 'Parte da projeção requer revisão dos dados de origem.',
  unallocated:
    'Há {{amount}} de folha projetada sem atribuição a uma linha do orçamento. Revise as contas e dimensões na configuração de folha.',
  provisionOrigin: 'Provisões: férias {{vacation}}; 13º {{thirteenth}}.',
  imported: 'importado',
  calculated: 'calculado',

  projected: 'Projetado',
  origin: 'Origem',
  amount: 'Valor',
  revision: 'Revisão',
  updatedAt: 'Atualizado em',
  title: 'Folha',
  budgetImpact:
    'Esta configuração afeta a projeção de folha dos orçamentos vinculados. Os valores são sempre por competência.',
  clt: 'CLT',
  proLabore: 'Pró-labore',
  rpa: 'RPA / autônomos',
  cltEnabled: 'Projetar CLT',
  proLaboreEnabled: 'Projetar pró-labore',
  rpaEnabled: 'Projetar RPA',
  method: 'Método',
  lastPosted: 'Última folha contabilizada',
  trailingAverage: 'Média dos meses fechados',
  cltMaxAge: 'Validade da base (meses)',
  proLaboreMaxAge: 'Validade da base (meses)',
  cltWindow: 'Janela da média (meses)',
  proLaboreWindow: 'Janela da média (meses)',
  rpaWindow: 'Janela da média (meses)',
  rpaOccurrences: 'Ocorrências mínimas',
  variableWindow: 'Janela da média (meses)',
  cltBasis:
    'Salário integral, encargos e provisões mensais de férias e 13º. Adiantamentos e eventos não são repetidos como despesas mensais.',
  proLaboreBasis: 'Remuneração e encargos da folha importada, sem presumir férias, 13º ou FGTS.',
  zeroMonths: 'Meses sem valor contam como zero.',
  benefits: 'Benefícios',
  transport: 'Vale-transporte',
  meals: 'Vale-refeição / alimentação',
  health: 'Saúde / odontologia',
  variables: 'Remuneração variável',
  bonus: 'Bônus',
  commission: 'Comissões',
  overtime: 'Horas extras',
  plannedPositions: 'Posições planejadas',
  includePlannedPositions: 'Incluir posições planejadas',
  plannedBasis:
    'Inclui posições CLT e PJ ainda planejadas. Ao contratar ou cancelar, a posição sai desta projeção.',
  pjBasis:
    'PJ contratado vem das contas recorrentes de natureza Folha e de seus compromissos no orçamento. Rubricas não classificadas ficam fora da projeção, com aviso.',
  impactTitle: 'Impacto nos orçamentos',
  affectedBudgets: '{{count}} orçamento(s) afetado(s)',
  before: 'Antes',
  after: 'Depois',
  difference: 'Diferença',
  period: 'Competência',
  confirm: 'Confirmar alteração',
  cancel: 'Cancelar',
  reason: 'Motivo da alteração',
  noBudgets: 'Nenhum orçamento vinculado será alterado.',
  selectEntity: 'Selecione a entidade para configurar o padrão de folha.',
  loadingError: 'Não foi possível carregar a configuração de folha.',
  invalidParams:
    'Revise os parâmetros de folha: janelas entre 1 e 12 meses e recorrência mínima dentro da janela.',
  scenario: 'Cenário de folha',
  scenarios: 'Cenários de folha',
  scenarioHelpLabel: 'Como funcionam os cenários de folha',
  scenarioHelpProjection:
    'O cenário define como a folha importada de CLT, RPA e pró-labore é projetada por competência no orçamento, incluindo benefícios, provisões e posições planejadas conforme a configuração em FP&A.',
  scenarioHelpSelection:
    'O orçamento usa o padrão da entidade até você selecionar outro cenário. A troca mostra uma prévia do impacto antes da confirmação e atualiza os valores projetados, sem alterar os limites orçados nem os valores já realizados.',
  scenarioHelpPj:
    'PJ já contratado continua em Comprometido, a partir das contas recorrentes de folha; não é calculado por este cenário.',
  configure: 'Configurar em FP&A',
  changeScenario: 'Alterar cenário',
  entityDefault: 'Padrão da entidade',
  explicit: 'Selecionado neste orçamento',
  fallback: 'O cenário anterior não está disponível. O padrão da entidade foi aplicado.',
  restricted: 'Atenção: valores de folha não estão sendo exibidos.',
  plannedClt: 'Posição planejada — CLT',
  plannedPj: 'Posição planejada — PJ',
};

export const payrollEn = {
  reasonRequired: 'Enter a reason for the change.',
  budgetImmutable: 'The payroll scenario can only change for draft or active budgets.',
  unallocatedImpact: 'Without a budget line: {{before}} → {{after}}.',
  snapshotRestricted:
    'This frozen report may contain payroll. Payroll data access is required to open it; historical values are not recalculated.',
  loading: 'Loading payroll configuration',
  saving: 'Saving change',
  saved: 'Change applied to linked budgets.',
  close: 'Close',
  retry: 'Try again',
  impactStale: 'Data changed. Review the impact again and confirm the change.',
  invalidScenario:
    'Select an active scenario with exactly one personnel model valid for this entity.',
  defaultRequired:
    'The default payroll scenario must remain active with its payroll rule. Configure it in the Payroll tab.',

  partialCoverage: 'Part of the projection needs its source data reviewed.',
  unallocated:
    '{{amount}} of projected payroll is not assigned to a budget line. Review payroll accounts and dimensions.',
  provisionOrigin: 'Provisions: vacation {{vacation}}; thirteenth salary {{thirteenth}}.',
  imported: 'imported',
  calculated: 'calculated',

  projected: 'Projected',
  origin: 'Source',
  amount: 'Amount',
  revision: 'Revision',
  updatedAt: 'Updated at',
  title: 'Payroll',
  budgetImpact:
    'This configuration affects payroll projections in linked budgets. All values follow competency months.',
  clt: 'CLT',
  proLabore: 'Pró-labore',
  rpa: 'RPA / independent workers',
  cltEnabled: 'Project CLT payroll',
  proLaboreEnabled: 'Project partner compensation',
  rpaEnabled: 'Project RPA',
  method: 'Method',
  lastPosted: 'Latest posted payroll',
  trailingAverage: 'Closed-month average',
  cltMaxAge: 'Maximum source age (months)',
  proLaboreMaxAge: 'Maximum source age (months)',
  cltWindow: 'Average window (months)',
  proLaboreWindow: 'Average window (months)',
  rpaWindow: 'Average window (months)',
  rpaOccurrences: 'Minimum occurrences',
  variableWindow: 'Average window (months)',
  cltBasis:
    'Full salary, employer charges and monthly vacation and thirteenth-salary provisions. Advances and one-off events are not repeated as monthly expenses.',
  proLaboreBasis:
    'Imported compensation and employer charges, without assumed CLT vacation, thirteenth salary or FGTS.',
  zeroMonths: 'Months without values count as zero.',
  benefits: 'Benefits',
  transport: 'Transport allowance',
  meals: 'Meal / food allowance',
  health: 'Health / dental',
  variables: 'Variable compensation',
  bonus: 'Bonuses',
  commission: 'Commissions',
  overtime: 'Overtime',
  plannedPositions: 'Planned positions',
  includePlannedPositions: 'Include planned positions',
  plannedBasis:
    'Includes CLT and PJ positions still planned. Hired or cancelled positions leave this projection.',
  pjBasis:
    'Current PJ contracts come from recurring Payroll bills and their budget commitments. Unclassified payroll items are excluded with a warning.',
  impactTitle: 'Budget impact',
  affectedBudgets: '{{count}} affected budget(s)',
  before: 'Before',
  after: 'After',
  difference: 'Difference',
  period: 'Competency',
  confirm: 'Confirm change',
  cancel: 'Cancel',
  reason: 'Reason for change',
  noBudgets: 'No linked budgets will change.',
  selectEntity: 'Select an entity to configure its payroll default.',
  loadingError: 'Could not load payroll configuration.',
  invalidParams:
    'Review payroll parameters: windows must be 1–12 months and minimum occurrences cannot exceed the window.',
  scenario: 'Payroll scenario',
  scenarios: 'Payroll scenarios',
  scenarioHelpLabel: 'How payroll scenarios work',
  scenarioHelpProjection:
    'The scenario defines how imported CLT, RPA and pro-labore payroll is projected by competency month in the budget, including benefits, provisions and planned positions according to the FP&A configuration.',
  scenarioHelpSelection:
    'The budget uses the entity default until you select another scenario. Switching shows an impact preview before confirmation and updates projected amounts without changing budgeted limits or actuals.',
  scenarioHelpPj:
    'Existing PJ contractors remain Committed, based on recurring payroll bills; they are not calculated by this scenario.',
  configure: 'Configure in FP&A',
  changeScenario: 'Change scenario',
  entityDefault: 'Entity default',
  explicit: 'Selected for this budget',
  fallback: 'The previous scenario is unavailable. The entity default has been applied.',
  restricted: 'Warning: payroll values are not displayed.',
  plannedClt: 'Planned position — CLT',
  plannedPj: 'Planned position — PJ',
};
